import React from 'react';
import PropTypes from 'prop-types';

const HtmlDiv = ({
  itemRef,
  style,
  children,
  onMouseDown,
  onMouseMove,
  onMouseUp,
  onMouseOut,
  onBlur,
}) => {
  return (
    <button
      type="button"
      ref={itemRef}
      style={{
        display: 'flex',
        overflow: 'hidden',
        boxSizing: 'border-box',
        ...style,
      }}
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      onMouseOut={onMouseOut}
      onBlur={onBlur}
      onTouchStart={onMouseDown}
      onTouchMove={onMouseMove}
      onTouchEnd={onMouseUp}>
      {children}
    </button>
  );
};
HtmlDiv.propTypes = {
  itemRef: PropTypes.any,
  style: PropTypes.any,
  children: PropTypes.any,
  onMouseDown: PropTypes.any,
  onMouseMove: PropTypes.any,
  onMouseUp: PropTypes.any,
  onMouseOut: PropTypes.any,
  onBlur: PropTypes.any,
};

export default HtmlDiv;
